/* eslint-disable react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { Link } from 'react-router-dom';

export const topShowsDefaultSorts = ['viewShareScore'];
export const trendingDefaultSorts = ['showPercentIncrease'];
export const anticipatedDefaultSorts = ['followers'];

export const topShowsColumns = [
  {
    Header: 'Show',
    accessor: 'show',
    className: 'tvt-tabular-data-table__network-top-shows-show',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/show/${original.showId}`}>{value}</Link>
    )
  },
  {
    Header: 'Network',
    accessor: 'network',
    className: 'tvt-tabular-data-table__network-top-shows-network',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/network/${original.networkId}`}>{value}</Link>
    )
  },
  {
    Header: 'Share of Views',
    accessor: 'viewShareScore',
    Cell: ({ cell: { value } }) => `${numeral(value * 100).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__network-top-shows-viewShareScore',
    sortDescFirst: true,
    sortType: 'basic'
  }
];

export const trendingColumns = [
  {
    Header: 'Show',
    accessor: 'showName',
    className: 'tvt-tabular-data-table__actor-affinity-show',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/show/${original.showId}`}>{value}</Link>
    )
  },
  {
    Header: 'Network',
    accessor: 'showNetworkName',
    className: 'tvt-tabular-data-table__actor-affinity-network',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/network/${original.showNetworkId}`}>{value}</Link>
    )
  },
  {
    Header: '% growth',
    accessor: 'showPercentIncrease',
    Cell: ({ cell: { value } }) => `${numeral(value * 100).format('0.0')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__actor-affinity-showPercentIncrease',
    sortDescFirst: true
  }
];

export const anticipatedColumns = [
  {
    Header: 'Show',
    accessor: 'show',
    className: 'tvt-tabular-data-table__network-anticipation-show',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/show/${original.showId}`}>{value}</Link>
    )
  },
  {
    Header: 'Release Date',
    accessor: 'releaseDate',
    className: 'tvt-tabular-data-table__network-anticipation-releaseDate'
  },
  {
    Header: 'Followers',
    accessor: 'followers',
    Cell: ({ cell: { value } }) => `${numeral(value).format('0,0')}`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__network-anticipation-followers',
    sortDescFirst: true
  }
];

export const formatGenderDemo = ({ data, loading }) => {
  if (loading) {
    return [];
  }

  return data.map(g => {
    const { gender, index, viewers } = g;
    const viewerIndex = numeral(index * 100).format('0.0');
    return {
      id: gender,
      viewers,
      label: (
        <tspan>
          <tspan className="user-demo-tspan__gender-gender">{gender}</tspan>
          <tspan className="user-demo-tspan__gender-viewerIndex" x={80}>
            {`${viewerIndex}%`}
          </tspan>
        </tspan>
      ),
      value: viewerIndex
    };
  });
};

export default {
  topShowsColumns,
  trendingColumns,
  trendingDefaultSorts,
  topShowsDefaultSorts,
  anticipatedDefaultSorts,
  anticipatedColumns,
  formatGenderDemo
};
